module.exports = __webpack_public_path__ + "static/media/ukerw-psp-medicine-prod.4eeccb9c.jpg";